<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<div>
								<p class="mb-0 font-weight-bold text-primary title">Ingreso Pago Manual</p>
							</div>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <v-form ref="form" v-model="validform" class="mt-6">
							<v-text-field
								label="Monto Pagado CLP"
								v-model="orderPayment.amount"
								type="number"
								outlined
								required
								dense
								hide-details
								class="custom-height-search custom-height-calendar"
								style="font-size: 14px;"
								@keydown.enter.prevent
							></v-text-field>
							<div class="d-flex flex-row align-center my-4">
								<v-select
									v-model="orderPayment.method"
									:items="paymentMethods"
									:menu-props="{ top: true, offsetY: true }"
									item-text="name"
									item-value="name"
									label="Forma de Pago"
									class="custom-height-search custom-height-calendar mr-2"
									outlined
									dense
									required
								></v-select>

								<v-menu
									ref="menu"
									v-model="menuDatePicker"
									:close-on-content-click="false"
									:return-value.sync="orderPayment.payment_date"
									transition="scale-transition"
									offset-y
									min-width="auto"
									eager
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											label="Fecha de Pago"
											v-model="orderPayment.payment_date"
											outlined
											required
											dense
											hide-details
											class="custom-height-search custom-height-calendar"
											style="font-size: 14px;"
											readonly
											v-bind="attrs"
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker
										v-model="orderPayment.payment_date"
										no-title
										scrollable
										:first-day-of-week="1"
										locale="es-cl"
										:picker-date.sync="pickerDate"
										event-color="red lighten-1"
										@input="(date) => $refs.menu.save(date)"
										class="pb-4"
									/>
								</v-menu>
							</div>

							<v-text-field
								label="Concepto"
								v-model="orderPayment.concept"
								outlined
								required
								dense
								hide-details
								class="custom-height-search custom-height-calendar"
								style="font-size: 14px;"
								@keydown.enter.prevent
							></v-text-field>

							<div class="d-flex align-center my-2">
								<div class="px-0">
									<v-btn
										depressed
										color="#524D4D"
										small
										outlined
										:loading="loading"
										:disabled="!!fileToUpload"
										@click="showFilePicker"
									>
										<v-icon small>mdi-file-document-plus-outline</v-icon>
										<p class="mb-0 ml-2 caption">Agregar Comprobante</p>
									</v-btn>
									<input 
										type="file" 
										ref="fileInput"
										style="display: none;"
										:accept="acceptedFileTypes"
									/>
								</div>
								<div class="d-flex justify-space-between align-center mx-2" v-if="fileToUpload">
									<p class="mb-0 caption truncate-text">Archivo: <b>{{fileToUpload.name}}</b></p>
									<v-btn
										depressed
										color="#524D4D"
										small
										icon
										@click="fileToUpload = null"
									>
										<v-icon small>mdi-close-outline</v-icon>
									</v-btn>
								</div>
							</div>

              <v-row align="center">
                <v-col cols="12">
                  <div class="d-flex flex-row justify-end">
                    <v-btn
                      class="mx-2 my-1"
                      color="white"
                      raised
                      @click="closeModal"
                    >
                      <p class="mb-0 text-primary">Cancelar</p>
                    </v-btn>
                    <v-btn
                      class="mx-2 my-1"
                      color="#524D4D"
                      raised
                      dark
                      :loading="loading"
                      @click="confirPayment"
                    >
                      <p class="mb-0">Confirmar</p>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {createManualPayment} from '@/helpers/api/general'

export default {
  name: 'ManualPaymentOrder',
	props: {},
  data: () => ({
		indexModal: + new Date(),
    validform: true,
		loading: false,
		menuDatePicker: false,
		pickerDate: null,
		paymentMethods: [
			{name: 'Transferencia'},
			{name: 'Cheque'},
			{name: 'Tarjeta de Crédito'},
			{name: 'Tarjeta de Débito'}
		],
		orderPayment: {
			payer_id: null,
			amount: 0,
			concept: null,
			item_id: null,
			item_type: null,
			method: 'Transferencia',
			payment_date: new Date().toISOString().split('T')[0],
		},
		fileToUpload: null,
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		acceptedFileTypes() {
			return [
				'application/pdf',
				'image/jpeg',
				'image/png',
			].join(',');
		},
  },
  mounted(){
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
		if(this.$store.state.general.manualPaymentOrderModal){
			this.orderPayment = {...this.orderPayment, ...this.$store.state.general.manualPaymentOrderModal.orderData}
		}
  },
  methods: {
    closeModal(){
			this.$store.commit('general/setManualPaymentOrderModal', null)
      this.validform = true
    },
		showFilePicker() {
			const input = this.$refs.fileInput;
			input.onchange = async (event) => {
				const file = event.target.files[0]
				this.fileToUpload = file
				input.value = null
			};
			input.click();
		},
		async confirPayment(){
			if(!this.fileToUpload){
				this.setMessage({
					message: 'Por favor selecciona un comprobante de pago.',
					title: 'Comprobante Requerido',
					type: 'error',
					icon: 'mdi-alert-circle',
					color: 'red'
				})
				return
			}
			if(this.$refs.form.validate()){
				this.loading = true
				const data = {
					...this.orderPayment,
					...{
						payment_date: `${this.orderPayment.payment_date} 12:00:00`,
						file: this.fileToUpload
					}
				}

				const formData = new FormData();
				Object.entries(data).forEach(([key, value]) => {
					formData.append(key, value);
				});
				const response = await createManualPayment(formData)
				if(response.code == 200){
					this.setMessage({
						message: 'Pago creado exitosamente',
						title: 'Pago Creado',
						type: 'success',
						icon: 'mdi-check-circle',
						color: 'green'
					})
					this.closeModal()
					eventBus.$emit('reloadInformation', data)
				}else{
					this.setMessage({
						message: response.message || 'Error al crear el pago',
						title: 'Error',
						type: 'error',
						icon: 'mdi-alert-circle',
						color: 'red'
					})
				}
				this.loading = false
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
		position: relative;
		width: 200px;
	}
	.profile-image{
		width: 100%;
		height: 150px;
	}
	.logo-text{
		position: absolute;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		width: 100%;
		color: white;
		font-size: 12px;
		padding: 5px 10px;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>